export default __webpack_public_path__ + "static/media/Rome.ef85dc75.jpg";